import {Checkbox} from 'antd';
import React, {useEffect, FC} from 'react';

import {TEntityValue, TLookupValue} from 'modules/data/data-types';
import {getMatchesBoolValue} from 'modules/data/utils/data.utils';
import {normalizeBoolValue, normalizeBoolValueString} from 'utils/common';
import '../bool-field/bool-field.less';

export interface IExternalEmployeeBoolFieldProps {
    value?: TEntityValue;
    label?: string;
    onChange?: (value: any) => void;
    disabled?: boolean;
    defaultValue?: string;
    dependentFieldData?: TLookupValue[];
}

export const ExternalEmployeeBoolField: FC<IExternalEmployeeBoolFieldProps> = ({
    value,
    label,
    onChange,
    disabled,
    defaultValue,
    dependentFieldData,
    ...props
}: IExternalEmployeeBoolFieldProps) => {
    const handleChange = async () => {
        if (onChange) onChange(getMatchesBoolValue(value as string));
    };

    useEffect(() => {
        if (Array.isArray(dependentFieldData)) {
            const resultValue = dependentFieldData?.slice(1).reduce((res: boolean, currentValue: any) => {
                res = res && normalizeBoolValue(currentValue?.attribute1);
                return res;
            }, normalizeBoolValue(dependentFieldData?.[0]?.attribute1));
            if (onChange && !disabled) onChange(normalizeBoolValueString(resultValue));
        }
    }, [dependentFieldData]);

    return (
        <Checkbox
            {...props}
            disabled={!onChange || disabled}
            onChange={handleChange}
            checked={normalizeBoolValue(value || defaultValue)}
        >{label}
        </Checkbox>
    );
};
